export const CITIES_IN_AZ = [
  'Abşeron',
  'Ağcabədi',
  'Ağdam',
  'Ağdaş',
  'Ağstafa',
  'Ağsu',
  'Astara',
  'Babək',
  'Bakı',
  'Balakən',
  'Bərdə',
  'Beyləqan',
  'Biləsuvar',
  'Daşkəsən',
  'Füzuli',
  'Qəbələ',
  'Qax',
  'Qazax',
  'Quba',
  'Qubadlı',
  'Qusar',
  'Hacıqabul',
  'İmişli',
  'İsmayıllı',
  'Cəbrayıl',
  'Cəlilabad',
  'Culfa',
  'Kəlbəcər',
  'Kəngərli',
  'Xaçmaz',
  'Xankəndi',
  'Xanlar',
  'Xocavənd',
  'Xudat',
  'Lənkəran',
  'Lerik',
  'Gəncə',
  'Masallı',
  'Mingəçevir',
  'Naftalan',
  'Naxçıvan',
  'Neftçala',
  'Oğuz',
  'Ordubad',
  'Qəbələ',
  'Qax',
  'Qazax',
  'Quba',
  'Qubadlı',
  'Qusar',
  'Saatlı',
  'Sabirabad',
  'Salyan',
  'Samux',
  'Şabran',
  'Şəki',
  'Şamaxı',
  'Şəmkir',
  'Şərur',
  'Şirvan',
  'Siazan',
  'Sumqayıt',
  'Tərtər',
  'Tovuz',
  'Ucar',
  'Yardımlı',
  'Yevlax',
  'Zəngilan',
  'Zaqatala',
  'Zərdab',
]

export const CITIES_IN_EN = [
  'Absheron',
  'Agcabadi',
  'Agdam',
  'Agdash',
  'Agstafa',
  'Agsu',
  'Astara',
  'Babek',
  'Baku',
  'Balakan',
  'Barda',
  'Beylagan',
  'Bilasuvar',
  'Dashkasan',
  'Fuzuli',
  'Gabala',
  'Gakh',
  'Ganja',
  'Gazakh',
  'Guba',
  'Gubadly',
  'Gusar',
  'Hajigabul',
  'Imishli',
  'Ismayilli',
  'Jabrayil',
  'Jalilabad',
  'Julfa',
  'Kalbajar',
  'Kangarli',
  'Khachmaz',
  'Khankendi',
  'Khanlar',
  'Khojavend',
  'Khudat',
  'Lenkaran',
  'Lerik',
  'Masally',
  'Mingachevir',
  'Naftalan',
  'Nakhchivan',
  'Neftchala',
  'Oghuz',
  'Ordubad',
  'Gabala',
  'Gakh',
  'Gazakh',
  'Guba',
  'Gubadly',
  'Gusar',
  'Saatli',
  'Sabirabad',
  'Salyan',
  'Samukh',
  'Shabran',
  'Sheki',
  'Shamakhi',
  'Shamkir',
  'Sharur',
  'Shirvan',
  'Siazan',
  'Sumgait',
  'Tartar',
  'Tovuz',
  'Ujar',
  'Yardimli',
  'Yevlakh',
  'Zangilan',
  'Zaqatala',
  'Zardab',
]
